export const EventsList = {
  CHANGED_CURRENT_CREDITOR: 'CHANGED_CURRENT_CREDITOR',
  MESSAGES_SEND_NEW_MESSAGE: 'MESSAGES_SEND_NEW_MESSAGE',
  CASE_DATA_UPDATED: 'CASE_DATA_UPDATED',
  OPEN_CHAT: 'OPEN_CHAT',
  CHAT_LOADED: 'CHAT_LOADED',
  CHAT_DISABLED: 'CHAT_DISABLED',
  MODULE_LOADED: 'MODULE_LOADED',
};
